import script from "./FeedbackTemplateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackTemplateDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackTemplateDialog.vue?vue&type=style&index=0&id=2a88259a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a88259a"]])

export default __exports__